import React, { useState, useEffect } from 'react';
import axios from 'axios';

const Messages = () => {
    const [messages, setMessages] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedMessage, setSelectedMessage] = useState(null);

    useEffect(() => {
        fetchMessages();
    }, []);

    const fetchMessages = async () => {
        try {
            const token = localStorage.getItem('admin_token');
            const response = await axios.get('http://localhost:8000/api/admin/contact-messages', {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            setMessages(response.data);
        } catch (error) {
            console.error('Error fetching messages:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleMarkAsRead = async (id) => {
        try {
            const token = localStorage.getItem('admin_token');
            await axios.put(`http://localhost:8000/api/admin/contact-messages/${id}/read`, {}, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            fetchMessages();
        } catch (error) {
            console.error('Error marking message as read:', error);
        }
    };

    const handleDelete = async (id) => {
        if (window.confirm('Are you sure you want to delete this message?')) {
            try {
                const token = localStorage.getItem('admin_token');
                await axios.delete(`http://localhost:8000/api/admin/contact-messages/${id}`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                fetchMessages();
                setSelectedMessage(null);
            } catch (error) {
                console.error('Error deleting message:', error);
            }
        }
    };

    if (loading) return <div className="admin-loading">Loading messages...</div>;

    return (
        <div>
            <div className="admin-header">
                <h2>Contact Messages</h2>
                <span style={{ color: '#6b7a8f', fontSize: '0.9rem' }}>
                    Total: {messages.length} | Unread: {messages.filter(m => !m.is_read).length}
                </span>
            </div>

            {messages.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '3rem', color: '#6b7a8f' }}>
                    <p>No messages found.</p>
                </div>
            ) : (
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '2rem' }}>
                    <div className="admin-table-wrapper">
                        <table className="admin-table">
                            <thead>
                                <tr>
                                    <th>From</th>
                                    <th>Subject</th>
                                    <th>Status</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {messages.map((message) => (
                                    <tr key={message.id} style={{ background: !message.is_read ? '#f0f7ff' : 'white' }}>
                                        <td>
                                            <strong>{message.name}</strong>
                                            <br />
                                            <small style={{ color: '#6b7a8f' }}>{message.email}</small>
                                        </td>
                                        <td>{message.subject || 'No subject'}</td>
                                        <td>
                                            <span className={`admin-status-badge ${message.is_read ? 'admin-status-active' : 'admin-status-inactive'}`}>
                                                {message.is_read ? 'Read' : 'Unread'}
                                            </span>
                                        </td>
                                        <td>
                                            <div className="admin-actions">
                                                <button 
                                                    className="admin-edit-btn" 
                                                    onClick={() => setSelectedMessage(message)}
                                                >
                                                    View
                                                </button>
                                                {!message.is_read && (
                                                    <button 
                                                        className="admin-edit-btn" 
                                                        onClick={() => handleMarkAsRead(message.id)}
                                                        style={{ background: '#dbeafe', color: '#2563eb' }}
                                                    >
                                                        Mark Read
                                                    </button>
                                                )}
                                                <button 
                                                    className="admin-delete-btn" 
                                                    onClick={() => handleDelete(message.id)}
                                                >
                                                    Delete
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <div>
                        {selectedMessage ? (
                            <div style={{ 
                                background: '#f8fafc', 
                                padding: '2rem', 
                                borderRadius: '12px',
                                border: '1px solid #e5e7eb'
                            }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '1rem' }}>
                                    <h3 style={{ margin: 0 }}>{selectedMessage.subject || 'No Subject'}</h3>
                                    <button 
                                        onClick={() => setSelectedMessage(null)}
                                        style={{ background: 'none', border: 'none', fontSize: '1.5rem', cursor: 'pointer' }}
                                    >
                                        ×
                                    </button>
                                </div>
                                <div style={{ marginBottom: '0.5rem' }}>
                                    <strong>From:</strong> {selectedMessage.name} ({selectedMessage.email})
                                </div>
                                <div style={{ marginBottom: '1rem' }}>
                                    <strong>Date:</strong> {new Date(selectedMessage.created_at).toLocaleString()}
                                </div>
                                <div style={{ 
                                    background: 'white', 
                                    padding: '1.5rem', 
                                    borderRadius: '8px',
                                    border: '1px solid #e5e7eb'
                                }}>
                                    <p style={{ whiteSpace: 'pre-wrap', margin: 0 }}>{selectedMessage.message}</p>
                                </div>
                                <div style={{ marginTop: '1rem', display: 'flex', gap: '1rem' }}>
                                    {!selectedMessage.is_read && (
                                        <button 
                                            className="admin-edit-btn" 
                                            onClick={() => {
                                                handleMarkAsRead(selectedMessage.id);
                                                setSelectedMessage(null);
                                            }}
                                        >
                                            Mark as Read
                                        </button>
                                    )}
                                    <button 
                                        className="admin-delete-btn" 
                                        onClick={() => {
                                            handleDelete(selectedMessage.id);
                                            setSelectedMessage(null);
                                        }}
                                    >
                                        Delete
                                    </button>
                                </div>
                            </div>
                        ) : (
                            <div style={{ 
                                display: 'flex', 
                                alignItems: 'center', 
                                justifyContent: 'center', 
                                height: '300px',
                                color: '#6b7a8f',
                                background: '#f8fafc',
                                borderRadius: '12px',
                                border: '1px solid #e5e7eb'
                            }}>
                                <p>Select a message to view its content</p>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default Messages;